import {TranslationObject} from '@colonist/i18n'
import {RoomState} from '../../../../../../shared/RoomState'
import {createDivIn, createOptionIn, createParagraphIn, createSelectIn, setElementInnerHTML} from '../../../../../shared/scripts/ui_utils/DomUtils'
import {SocketLobbySend} from '../../../../../shared/scripts/socket/SocketLobbySend'
import {RoomActionSetSeedOrder, RoomSeedOrderSelectionData} from '@colonist/lobby-types'
import {PlayerColor} from '@colonist/game-states'
import {notificationController, socket} from '../../../../../shared/scripts/EntryShared'
import {LobbyImage} from '@colonist/types'

export class UIRoomCenterSeedOrderSelectionController {
    parentContainer: HTMLDivElement
    mainContainer: HTMLDivElement
    roomState: RoomState
    seedOrderSelectionData: RoomSeedOrderSelectionData
    checkMarkButton: HTMLDivElement

    constructor(scrollContainer: HTMLDivElement) {
        this.parentContainer = scrollContainer
    }

    updateSeedOrderSelection(roomState: RoomState, footer: HTMLDivElement, data: RoomSeedOrderSelectionData) {
        this.roomState = roomState
        this.seedOrderSelectionData = data
        if(this.mainContainer != undefined) setElementInnerHTML(this.mainContainer, {key: 'strings:colonistCommon.utils.emptyString'})
        this.mainContainer = createDivIn(this.parentContainer, 'seed_order_selection_container')
        const amIHost = this.roomState.hostSession.userSessionId == socket.controller.session.id
        const seedOrderMap = new Map(data.seedOrder)
        for(const [index] of roomState.getSessions().entries()) {
            const seedOrder = index + 1
            const sessionContainer = createDivIn(this.mainContainer, 'seed_order_selection_session_container')
            createParagraphIn(sessionContainer, {key: 'strings:colonistCommon.utils.#buffer', options: {value: `#${seedOrder}`}}, 'seed_order_selection_session_text')
            const playerNameSelector = createSelectIn(sessionContainer, '', '', (value) => UIRoomCenterSeedOrderSelectionController.onSetSeedOrder(value, seedOrder, playerNameSelector))

            const defaultText: TranslationObject = amIHost ? {key: 'strings:roomPage.orderSelection.seedOrderSelection.selectPlayer'} : {key: 'strings:roomPage.orderSelection.seedOrderSelection.waitingForHost'}
            createOptionIn(playerNameSelector, 'Select Player', defaultText, true)
            playerNameSelector.disabled = !amIHost

            const bufferKey = 'strings:colonistCommon.utils.#buffer'
            for(const session of roomState.getSessions()) createOptionIn(playerNameSelector, session.selectedColor.toLocaleString(), {key: bufferKey, options: {value: `${session.username}`}})

            if(!seedOrderMap.has(seedOrder)) continue
            const playerColor = roomState.getSessions().find((session) => session.selectedColor == seedOrderMap.get(seedOrder))?.selectedColor.toLocaleString()
            playerNameSelector.value = playerColor ?? 'PlayerNotFound'
        }

        if(!amIHost) return
        if(this.checkMarkButton != undefined) return
        this.checkMarkButton = createDivIn(footer, 'btn_general btn_general_check')
        this.checkMarkButton.onclick = () => this.onConfirmSelection()
    }

    setFooterContentVisibility(visible: boolean) {
        if(this.checkMarkButton == undefined) return
        this.checkMarkButton.hidden = !visible
    }

    setScrollContainerContentVisibility(visible: boolean) {
        if(this.mainContainer == undefined) return
        this.mainContainer.hidden = !visible
    }

    private static onSetSeedOrder(value: string, seedOrder: number, playerNameSelector: HTMLSelectElement) {
        const currentValue = parseInt(playerNameSelector.value, 10)
        if(isNaN(currentValue)) playerNameSelector.remove(playerNameSelector.selectedIndex)
        const playerColor = parseInt(value, 10) as PlayerColor
        const seedOrderSelectionData: RoomActionSetSeedOrder = {
            color: playerColor,
            order: seedOrder,
        }
        SocketLobbySend.clickedRoomSetSeedOrder(seedOrderSelectionData)
    }

    private onConfirmSelection() {
        if(this.seedOrderSelectionData == undefined) return
        if(this.seedOrderSelectionData.seedOrder.length != this.roomState.getSessionCount()) return notificationController.showNotification(LobbyImage.XMark, {key: 'strings:roomPage.notifications.assignAllPlayersToASeed'})
        const playerColors = this.seedOrderSelectionData.seedOrder.map((entry) => entry[1])
        const uniquePlayerColors = new Set(playerColors)
        if(uniquePlayerColors.size != playerColors.length) return notificationController.showNotification(LobbyImage.XMark, {key: 'strings:roomPage.notifications.cantAssignAPlayerToMultipleSeeds'})
        SocketLobbySend.clickedRoomStartPlayOrderSelection()
    }
}
